// @ts-nocheck
import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import Users from '../components/users/list'
import CreateUser from '../components/users/create'
import EditUser from '../components/users/edit'
import ImpersonateUser from '../components/users/impersonate'

import RefreshCoachList from '../components/coach-users/refresh'
import WriteNowImport from '../components/writenow-import'
import WriteNowMergeFieldsImportPage from '../components/WriteNowMergeFieldsImportPage'
import MemberImport from '../components/member-import'

import BuddyMatches from '../components/buddy-matches/list'
import CreateBuddyMatch from '../components/buddy-matches/create'
import EditBuddyMatch from '../components/buddy-matches/edit'
import EditBuddyRequest from '../components/buddy-requests/edit'

import BuddyRequests from '../components/buddy-requests/list'
import ImportDataTypes from '../components/member-import/importDataTypes'
import LogHistory from '../components/log-history/logHistory'
import LogDetail from '../components/log-history/detail'

const SecurityRoutes = (
  <Route path='security'>
    <Route path='users'>
      <IndexRoute component={Users} />
      <Route path='create' component={CreateUser} />
      <Route path=':userId/edit' component={EditUser} />
      <Route path=':userId/impersonate' component={ImpersonateUser} />
    </Route>

    <Route path='coach-users'>
      <IndexRedirect to='refresh' />
      <Route path='refresh' component={RefreshCoachList} />
    </Route>

    <Route path='writenow-import' component={WriteNowImport} />
    <Route path='writenow-merge-fields-import' component={WriteNowMergeFieldsImportPage} />

    <Route component={ImportDataTypes}>
      <IndexRoute to='member-import' />
      <Route path='member-import'>
        <IndexRoute component={MemberImport} />
      </Route>
      <Route path='log-history'>
        <IndexRoute component={LogHistory} />
        <Route path='log-history' component={LogHistory} />
        <Route path=':logId/detail' component={LogDetail} />
      </Route>
    </Route>

    <Route path='buddy-matches'>
      <IndexRoute component={BuddyMatches} />
      <Route path='create' component={CreateBuddyMatch} />
      <Route path=':buddyMatchId/edit' component={EditBuddyMatch} />
    </Route>

    <Route path='buddy-requests'>
      <IndexRoute component={BuddyRequests} />
      <Route path=':buddyRequestId/edit' component={EditBuddyRequest} />
    </Route>
  </Route>
)

export default SecurityRoutes
